/**
 * Clients, partners, and products LogitsLab has built with or for.
 */

/** Carousel slides for Partners section (side-button navigation) */
export const PARTNER_SLIDES = [
  {
    id: 'camereye',
    kind: 'client',
    name: 'CamerEye',
    badge: 'AI developed for',
    role: 'Pool safety & outdoor AI',
    href: 'https://camereye.ai/',
    video: '/assets/videos/DistressDetection.mp4',
    image: '/assets/images/partners/camereye-poster.jpg',
    alt: 'CamerEye pool safety and outdoor monitoring',
    summary:
      'AI smart-pool systems for 24/7 monitoring, human/pet detection, and distress alerts.',
    meta: ['Detection', 'Tracking', 'Distress'],
  },
  {
    id: 'byondbites',
    kind: 'partner',
    name: 'Byondbites',
    badge: 'Official tech partner',
    role: 'Building with us',
    href: 'https://byondbites.com/',
    video: '/assets/videos/byondbites-ayra.mp4',
    image: '/assets/images/posters/byondbites-ayra.jpg',
    alt: 'Byondbites Ayra AI kitchen companion demo',
    summary:
      'AI kitchen intelligence for the GCC and South Asia. LogitsLab is the official technology partner developing their product — including Ayra, the AI kitchen companion.',
    meta: ['LLM / vision', 'Recipes', 'Mobile'],
  },
  {
    id: 'valken',
    kind: 'partner',
    name: 'Valken',
    badge: 'Official tech partner',
    role: 'AI-native real estate sales',
    href: 'https://valken.xyz/',
    image: '/assets/images/partners/valken.png',
    alt: 'Valken — AI sales motion for real estate builders',
    summary:
      'Where launches become closures — AI sales motion for builders: scan demand, qualify in any language, book site visits into the calendar. LogitsLab is the official tech partner.',
    meta: ['Lead gen', 'Multilingual calls', 'Site visits'],
  },
  {
    id: 'selfagentic',
    kind: 'partner',
    name: 'SelfAgentic',
    badge: 'Official tech partner',
    role: 'No-code AI agents',
    href: 'https://www.selfagentic.in/',
    image: '/assets/images/partners/selfagentic.jpg',
    alt: 'SelfAgentic no-code collaborative AI agents',
    summary:
      'AI agents that work for you — create agents that collaborate, use your tools, and run marketing, sales, product, and support workflows without code. LogitsLab is the official tech partner.',
    meta: ['Agents', 'No-code', 'Workflows'],
  },
  {
    id: 'mindkshetra',
    kind: 'product',
    name: 'MindKshetra',
    badge: 'Product by LogitsLab',
    role: 'Live product',
    href: 'https://mind.logitslab.com/',
    image: '/assets/images/partners/mindkshetra-hero.jpg',
    alt: 'MindKshetra — Bhagavad Gita companion product',
    tagline: 'Clarity from the Gita, for the battlefield of the mind.',
    summary:
      'Explore all 18 chapters, match verses to mood, or speak with Madhav — guidance grounded in real teachings.',
    meta: ['Explore', 'Mood', 'Ask Madhav'],
  },
  {
    id: 'parkview',
    kind: 'client',
    name: 'ParkView',
    badge: 'AI developed for',
    role: 'Parks · people · weather',
    href: 'https://parkviewlive.com/',
    image: '/assets/images/partners/parkview.jpg',
    alt: 'Park landscape representing ParkView live park views',
    summary:
      'Live park views, activity discovery, and updates before you arrive — your window to parks, people, and weather.',
    meta: ['Live cameras', 'Activities', 'Outdoor AI'],
  },
  {
    id: 'looq',
    kind: 'client',
    name: 'Looq AI',
    badge: 'AI developed for',
    role: 'Spatial / infrastructure AI',
    href: 'https://looq.ai/',
    image: '/assets/images/partners/looq.jpg',
    alt: 'Field survey and spatial capture for Looq AI',
    summary:
      'Handheld photogrammetry and AI for survey-grade 3D point clouds — without LiDAR or drones.',
    meta: ['qCam', 'qAI', 'qApp'],
  },
  {
    id: 'rtsh',
    kind: 'client',
    name: 'RTSH',
    badge: 'AI developed for',
    role: 'Camera & AI · United States',
    href: 'https://rtsh.co/',
    image: '/assets/images/partners/rtsh.jpg',
    alt: 'Security camera and edge AI for RTSH',
    summary:
      'US camera and AI company building intelligent imaging systems for real-world perception.',
    meta: ['Cameras', 'Edge AI', 'Perception'],
  },
  {
    id: 'nuvve',
    kind: 'client',
    name: 'Nuvve',
    badge: 'AI developed for',
    role: 'Energy / V2G',
    href: 'https://nuvve.com/',
    image: '/assets/images/partners/nuvve.jpg',
    alt: 'EV charging and vehicle-to-grid systems for Nuvve',
    summary:
      'Vehicle-to-grid and distributed energy platforms — EV batteries, chargers, and grid services.',
    meta: ['V2G', 'Grid', 'Fleets'],
  },
  {
    id: 'toptal',
    kind: 'client',
    name: 'Toptal',
    badge: 'Engaged via / delivered through',
    role: 'Global talent network',
    href: 'https://www.toptal.com/',
    image: '/assets/images/partners/toptal.jpg',
    alt: 'Remote engineering collaboration via Toptal',
    summary:
      'Exclusive network of top freelance talent — AI engineering delivered through senior engagements for high-stakes client work worldwide.',
    meta: ['Engineering', 'Global', 'Delivery'],
  },
];

/** Fullscreen hero carousel */
export const HERO_SLIDES = [
  {
    id: 'tracking',
    src: '/assets/videos/AdvancedDetectiionAndTracking.mp4',
    poster: '/assets/images/posters/AdvancedDetectiionAndTracking.jpg',
    label: 'Advanced Detection & Tracking',
  },
  {
    id: 'byondbites',
    src: '/assets/videos/byondbites-ayra.mp4',
    poster: '/assets/images/posters/byondbites-ayra.jpg',
    label: 'Byondbites',
  },
  {
    id: 'drowning',
    src: '/assets/videos/DistressDetection.mp4',
    poster: '/assets/images/posters/DistressDetection.jpg',
    label: 'Drowning Detection',
  },
  {
    id: 'anpr',
    src: '/assets/videos/AutomaticNumberPlateDetection-ANPR.mp4',
    poster: '/assets/images/posters/AutomaticNumberPlateDetection_ANPR_.jpg',
    label: 'ANPR',
  },
  {
    id: 'crowd',
    src: '/assets/videos/CrowdDetectionTracking-Counting.mp4',
    poster: '/assets/images/posters/CrowdDetection.jpg',
    label: 'Crowd Detection & Counting',
  },
];

/** Featured narrative cards for the home proof section */
export const FEATURED_STORIES = [
  {
    id: 'byondbites',
    label: 'OFFICIAL PARTNER',
    title: 'Byondbites — building Ayra with us',
    summary:
      'Official partner. We are developing their AI kitchen product: scan the pantry, get culturally relevant recipes, waste less food.',
    href: 'https://byondbites.com/',
    external: true,
    video: '/assets/videos/byondbites-ayra.mp4',
    poster: '/assets/images/posters/byondbites-ayra.jpg',
    mediaType: 'video',
    accent: 'partner',
  },
  {
    id: 'mindkshetra',
    label: 'LIVE',
    title: 'MindKshetra — Gita companion for the mind',
    summary:
      'Our live product: explore verses, begin with a mood, or ask Madhav. Clarity from the Gita when duty and doubt collide.',
    href: 'https://mind.logitslab.com/',
    external: true,
    image: '/assets/images/partners/mindkshetra-hero.jpg',
    mediaType: 'image',
    accent: 'mind',
  },
  {
    id: 'camereye',
    label: 'AI DEVELOPED FOR',
    title: 'CamerEye — vision that watches the water',
    summary:
      'AI for pool safety: detection, tracking, and distress cues on real outdoor cameras.',
    href: 'https://camereye.ai/',
    external: true,
    video: '/assets/videos/DistressDetection.mp4',
    poster: '/assets/images/partners/camereye-poster.jpg',
    mediaType: 'video',
    accent: 'case',
  },
  {
    id: 'selfagentic',
    label: 'TECH PARTNER',
    title: 'SelfAgentic — AI agents that work for you',
    summary:
      'Official tech partner. No-code agents that collaborate, use your tools, and run marketing, sales, product, and support workflows.',
    href: 'https://www.selfagentic.in/',
    external: true,
    image: '/assets/images/partners/selfagentic.jpg',
    mediaType: 'image',
    accent: 'partner',
  },
];
